import { RouteConfig } from 'vue-router';
import InvitationsOverview from '@/views/invitations/InvitationsOverview.vue';
import InviteModal from '@/views/invitations/InviteModal.vue';
import PageModal from '@/components/modals/PageModal.vue';
import InviteResendModal from '@/views/invitations/InviteResendModal.vue';


const routes: Array<RouteConfig> = [
	{
		path: '/invitations/',
		name: 'invitations',
		component: InvitationsOverview,
		children: [
			{
				path: '/invitations/invite',
				name: 'invite',
				component: PageModal,
				props: {
					title: 'Einladung versenden',
					component: InviteModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
			{
				path: '/invitations/resend-invite',
				name: 'resendInvite',
				component: PageModal,
				props: {
					title: 'Einladen erneut versenden',
					component: InviteResendModal,
					modalStyle: 'width: fit-content; align-self: center',
					reAddConfirmLeaving: true,
				},
				meta: {
					disableScroll: true,
				},
			},
		],
	},
];

export default routes;
